  import { createApiClient } from 'Network/ApiClient';
  
export const LoginAxiosInstance = createApiClient('user/');


